import Styles from './MonaFooter.module.css'

export interface FeaturedRepository {
  nameWithOwner: string
  description: string | null
  url: string
  newStars: number
}

export interface MonaFooterProps {
  mona: {
    variant: 'dark' | 'purple'
  }
  repos: {
    items: FeaturedRepository[]
    starsTemplate: string
  }
}

export const defaultProps: Partial<MonaFooterProps> = {}

export const MonaFooter = (props: MonaFooterProps) => {
  const initializedProps: MonaFooterProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['MonaFooter']}>MonaFooter</div>
}
